import {FC} from 'react';
//formik
import {Field, useFormikContext} from 'formik';
import {CreateEventFormValues} from '../../formConfiguration';
//mui
import {Box, Typography} from '@mui/material';
//constants
import {BODY2, FIELD, FIELD_LABEL, SUBTITLE1} from '@/utils/constants';
//helpers
import {setRequiredLabel} from '@/utils/helpers';
//components
import Switch from '@/shared/components/Switches/Switch';
import DatePicker from '@/shared/components/DatePicker';
import TimePicker from '@/shared/components/TimePicker';
//styles
import {auctionContentStyle} from './AuctionContent.styles';

const AuctionContent: FC = () => {
	const {
		values: {isOnlineAuction, isFundTheMission},
	} = useFormikContext<CreateEventFormValues>();

	return (
		<Box>
			<Box sx={auctionContentStyle.auction}>
				<Typography variant={SUBTITLE1} sx={auctionContentStyle.title}>
					Auction:
				</Typography>
				<Field
					id={FIELD.isOnlineAuction}
					name={FIELD.isOnlineAuction}
					component={Switch}
					checked={isOnlineAuction}
				/>
				<Typography variant={BODY2} sx={auctionContentStyle.subtitle}>
					Online auction
				</Typography>
			</Box>

			<Box sx={auctionContentStyle.dateWrapper}>
				<Box sx={auctionContentStyle.date}>
					<Field
						id={FIELD.startAuctionDate}
						name={FIELD.startAuctionDate}
						label={setRequiredLabel(FIELD_LABEL.startAuctionDate)}
						component={DatePicker}
						disabled={!isOnlineAuction}
						sx={auctionContentStyle.dateMonthYear}
					/>
					<Field
						id={FIELD.startAuctionTime}
						name={FIELD.startAuctionTime}
						label={setRequiredLabel(FIELD_LABEL.startTime)}
						component={TimePicker}
						disabled={!isOnlineAuction}
						parentClassName={auctionContentStyle.time}
					/>
				</Box>

				<Box sx={auctionContentStyle.date}>
					<Field
						id={FIELD.endAuctionDate}
						name={FIELD.endAuctionDate}
						label={setRequiredLabel(FIELD_LABEL.endAuctionDate)}
						component={DatePicker}
						disabled={!isOnlineAuction}
						sx={auctionContentStyle.dateMonthYear}
					/>
					<Field
						id={FIELD.endAuctionTime}
						name={FIELD.endAuctionTime}
						label={setRequiredLabel(FIELD_LABEL.endTime)}
						component={TimePicker}
						disabled={!isOnlineAuction}
						parentClassName={auctionContentStyle.time}
					/>
				</Box>
			</Box>

			<Box sx={auctionContentStyle.mission}>
				<Typography variant={SUBTITLE1} sx={auctionContentStyle.title}>
					Fund the Mission:
				</Typography>
				<Field
					id={FIELD.isFundTheMission}
					name={FIELD.isFundTheMission}
					component={Switch}
					checked={isFundTheMission}
				/>
				<Typography variant={BODY2} sx={auctionContentStyle.subtitle}>
					Visible on event webpage
				</Typography>
			</Box>
		</Box>
	);
};

export default AuctionContent;
